import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/aboutus3.png" className="img-responsive" alt="aboutus" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              
                {/* Misión y Visión con estilo similar a Why Choose Us */}
                <div className="list-style">
                  <div className="col-lg-6 col-sm-6 col-xs-12">
                    <h3>Our Mission</h3>
                    <ul>
                      <li>
                        {props.data ? props.data.mission : "loading..."}
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-sm-6 col-xs-12">
                    <h3>Our Vision</h3>
                    <ul>
                      <li>
                        {props.data ? props.data.vision : "loading..."}
                      </li>
                    </ul>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
